exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-custom[data-v-39827465]{background-color:#fff;max-width:800px;padding:20px;height:100vh;overflow-y:auto}#description_sync[data-v-39827465]{width:100%;padding:1em;height:150px}#textarea-max-chars[data-v-39827465]{font-size:.8em;color:var(--checkbox-gray)}p.subdesc[data-v-39827465],span.subdesc[data-v-39827465]{margin-top:0;color:var(--checkbox-gray)}", ""]);

// exports
